import { gql, TypedDocumentNode } from "@apollo/client";

import {
  AwsIntegration,
  AwsRegion,
  ScanProvider,
  ScanProviderSchema,
  ScanResourceType,
  WorkerPool,
} from "types/generated";

type ScanProviderSchemaDetails = Pick<ScanProviderSchema, "majorVersions"> & {
  resourceTypes: Array<Pick<ScanResourceType, "type" | "subcategory">>;
  configSchema: {
    regions: Array<Pick<AwsRegion, "id" | "location" | "region">>;
  };
};

type AttachableAwsIntegration = Pick<
  AwsIntegration,
  "id" | "name" | "legacy" | "generateCredentialsInWorker"
>;

type AttachableWorkerPool = Pick<WorkerPool, "id" | "name">;

type GetScanFormOptionsData = {
  scanProviderSchemas: ScanProviderSchemaDetails[];
  attachableAwsIntegrationsInSpace: AttachableAwsIntegration[];
  attachableWorkerPoolsInSpace: AttachableWorkerPool[];
};

type GetScanFormOptionsVariables = {
  provider: ScanProvider;
  spaceId: string;
};

export const GET_SCAN_FORM_OPTIONS: TypedDocumentNode<
  GetScanFormOptionsData,
  GetScanFormOptionsVariables
> = gql`
  query GetScanFormOptions($provider: ScanProvider, $spaceId: ID!) {
    scanProviderSchemas(provider: $provider) {
      majorVersions
      resourceTypes {
        type
        subcategory
      }
      configSchema {
        ... on AWSScanConfigSchema {
          regions {
            id
            location
            region
          }
        }
      }
    }
    attachableAwsIntegrationsInSpace(id: $spaceId) {
      id
      name
      legacy
      generateCredentialsInWorker
    }
    attachableWorkerPoolsInSpace(id: $spaceId) {
      id
      name
    }
  }
`;
